import React from 'react';
import { useEffect, useState, useRef } from 'react';
import '../App.css'
//
import DownArrow from '../../../svgs/DownArrow.js';
import CompleteSvg from '../../../svgs/CompleteSvg';
import { loginWithEmailOtp, requestOtpWithEmail, uploadNewUserProfile } from "../../../services/users.js";
import { participateEvent,checkIfEmailRegisteredEvent } from "../../../services/events.js";
import LoadingPage from "../../../components/Loading";
//
import Nav from '../components/Nav.js';
import Footer from '../components/Footer.js';

const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};
const AGE = ['18-25', '26-29', '30-35', '36-49', '50-60', '60+']
const EDU = ['學士 Bachelor','碩士 Master','博士 Doctor', '其他 Other']
const WORKEX = [
    '應屆畢業生 Fresh graduates',
    '1-2年工作經驗 working experience',
    '3-5年工作經驗 working experience',
    '6-9年工作經驗 working experience',
    '10年及以上工作經驗 working experience'
]
const VISA = [
    '優秀人才入境計劃 Quality Migrant AdmissionScheme',
    '輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals',
    '一般就業政策（外籍專才）General Employment Policy',
    '高端人才通行證計劃 Top Talent Pass Scheme',
    '科技人才入境計劃 Technology Talent Admission Scheme',
    '非本地畢業生留港/回港計劃 IANG Visa',
    '在讀學生簽證 Student Visa',
    '受養人簽證 Dependant',
    '通過人才計劃來港已永久 HK Permanent Resident',
    '香港本地專業人士 HK Native Professionals',
    '計劃申請香港人才計劃中 Apply',
]
const AboutUs = ({scrollRef, handleSetRightNav}) => {
    const [isloading,setisloading]=useState(false);
    const ref1=useRef(null)
    const ref2=useRef(null)
    const ref3=useRef(null)
    const ref4=useRef(null)
    const ref5=useRef(null)
    const ref6=useRef(null)
    const [num1,setnum1]=useState('')
    const [num2,setnum2]=useState('')
    const [num3,setnum3]=useState('')
    const [num4,setnum4]=useState('')
    const [num5,setnum5]=useState('')
    const [num6,setnum6]=useState('')
    const [countdown,setcountdown]=useState(0)

    const [isVerified,setisVerified]=useState(false)
    const [isShowOtpPopup,setisShowOtpPopup]=useState(false)
    const [data,setData]=useState({})
    const onChangeEmail=(e)=>{setData({...data,email:e.target.value?.toLowerCase()})}
    const onChangeMobile=(e)=>{setData({...data,mobile:e.target.value})}
    const onChangeDegree=(e)=>{setData({...data,degree:e.target.value})}
    const onChangefirstname=(e)=>{setData({...data,firstname:e.target.value})}
    const onChangelastname=(e)=>{setData({...data,lastname:e.target.value})}
    const onChangeenglishName=(e)=>{setData({...data,englishName:e.target.value})}
    const onChangecompany=(e)=>{setData({...data,company:e.target.value})}
    const onChangeSchoolMajor=(e)=>{setData({...data,school:e.target.value})}
    const onChangeWechat=(e)=>{setData({...data,wechat:e.target.value})}
    const onChangePosition=(e)=>{setData({...data,position:e.target.value})}
    const onChangeTitle=(e)=>{setData({...data,title:e.target.value})}
    const onChangeEmployer=(e)=>{setData({...data,employer:e.target.value})}
    useEffect(() => {
        console.log(data)
    },[data])

    const [windowSize, setWindowSize] = useState(getWindowSize());
    function getWindowSize() {const {innerWidth, innerHeight} = window;return {innerWidth, innerHeight};}
        useEffect(()=>{
            function handleWindowResize() {setWindowSize(getWindowSize()); }
            window.addEventListener('resize', handleWindowResize);
            return () => {window.removeEventListener('resize', handleWindowResize);};
    },[])

    const [showRegisterError,setshowRegisterError]=useState('')
    const onRequestOtp=async ()=>{
        if(isVerified)return
        if(!validateEmail(data?.email)){
            alert('電子郵件無效，請重新輸入');
            return
        }
        setisloading(true)
        let checkEmail = await checkIfEmailRegisteredEvent('684be98a7a415acb4a6200c6',data.email)
        if(checkEmail.errno){
            alert(checkEmail.message||'error')
            setisloading(false)
            return
        }
        if(checkEmail?.result!==false){
            setshowRegisterError('該郵箱已經登記過，如用同一信箱登記，將覆蓋您原先的登記信息，如確認修改，請繼續填寫。')
        }else{
            setshowRegisterError('')
        }

        let result = await requestOtpWithEmail(data.email)
        if(result.errno){
            alert(`${result?.message}||Error (70001)`);
            setisloading(false)
            return
        }
        setisShowOtpPopup(true)
        setisVerified(false)
        setcountdown(120)
        setisloading(false)
    }
    const cancelOtp=()=>{
        setisShowOtpPopup(false)
        setisVerified(false)
        setData({...data,token:null});
        setnum1('');setnum2('');setnum3('');setnum4('');setnum5('');setnum6('');
    }


    const handleLoginButton=async ()=>{
        const otp = `${num1}${num2}${num3}${num4}${num5}${num6}`
        if((!otp)||otp.length!==6){alert('驗證碼無效，請重新輸入');return;}
        
        setisloading(true)
        try{
            setisloading(true)
            let res = await loginWithEmailOtp(data.email,otp)
            if(res.errno){
                alert(res.message||'驗證碼無效，請重新輸入');
                setisloading(false)
                return
            }
            
            let token = res?.token?.token
            setData({...data,token});
            
            setisShowOtpPopup(false)
            setisVerified(true)
            setnum1('');setnum2('');setnum3('');setnum4('');setnum5('');setnum6('');
            setisloading(false)
           

        }catch(e){
            console.log(e)
            alert(e.message)
        }finally{
            setisloading(false)
        }
    }
    const handleOtpInput=(num)=>(e)=>{
        if(num===1){ setnum1(e.target.value);if(e.target.value.length>=1)ref2.current.focus();
        }else if(num===2){ setnum2(e.target.value);if(e.target.value.length>=1)ref3.current.focus();
        }else if(num===3){ setnum3(e.target.value);if(e.target.value.length>=1)ref4.current.focus();
        }else if(num===4){ setnum4(e.target.value);if(e.target.value.length>=1)ref5.current.focus();
        }else if(num===5){ setnum5(e.target.value);if(e.target.value.length>=1)ref6.current.focus();
        }else if(num===6){ setnum6(e.target.value);}
    }
    useEffect(()=>{
        let i = setInterval(()=>{setcountdown(c=>{return (c-1)<=0?0:c-1}) },1000)
        return ()=>{clearInterval(i)}
    },[])

    const [isShowSuccessfulPage,setisShowSuccessfulPage]=useState(false)
    const handleCompleteRegister=async ()=>{
        if(!isVerified){
            alert('請先透過發送驗證碼來驗證您的電子郵件')
            return
        } 
        if( !data.firstname ){ alert('請輸入您的名'); return }
        if( !data.lastname ){ alert('請輸入您的姓'); return }
        if( !data.age ){ alert('請輸入您的年齡'); return }
        // if( !data.mobile ){ alert('請輸入您的手機號'); return }
        // if( !data.wechat ){ alert('請輸入您的微信號'); return }
        // if( !data.title ){ alert('請選擇您的性別'); return }
        if( !data.email ){ alert('請選擇您的電郵'); return }
        if( !data.degree ){ alert('請輸入您學位'); return }
        // if( !data.school ){ alert('請輸入您的學校及專業'); return }
        if( !data.workEx ){ alert('請輸入您的工作經驗'); return }
        // if( !data.employer ){ alert('請輸入您的工作單位名稱及職位'); return }
        if( !data.visa ){ alert('香港簽證類型'); return }
        if((!data.isAttendEvent1) && (!data.isAttendEvent2)){alert('請選擇出席環節'); return }
        if(!data.isAcknowledged){alert('您必須同意該聲明才能繼續'); return }
        if(data.firstname.length>=60){alert('你的名字太長');return}

        setisloading(true)
        
        let json={
            firstname: data?.firstname,
            lastname: data?.lastname,
        }
        if(data.englishName)json.englishName=data.englishName
        // if(data.title){
        //     json.title=data.title==='男 Male'?'先生':'女士'
        //     json.gender = (data.title==='男 Male')?'男性':'女性'
        // }
        // if(data.gender)json.gender=data.gender
        if(data.dateOfBirthMonth)json.dateOfBirthMonth=data.dateOfBirthMonth
        if(data.dateOfBirthDate)json.dateOfBirthDate=data.dateOfBirthDate
        if(data.position)json.position=data.position
        if(data.company)json.company=data.company
        if(data.title)json.title = data.title
        //business profile
        json.businessProfile={email:data.email}
        if(data.mobile)json.businessProfile.mobile=data.mobile
        if(data.wechat)json.businessProfile.wechat=data.wechat
        let result = await uploadNewUserProfile(data?.token,json)
        if(result.errno){
            alert(`${JSON.stringify(result.message||"Error (70007)")}`)
            setisloading(false)
            return
        }else{
            let result2 = await participateEvent(data?.token,'684be98a7a415acb4a6200c6',{
                age: data?.age,
                degree: data?.degree,
                school: data?.school,
                workEx: data?.workEx,
                visa: data?.visa,
                isAttendEvent1:data?.isAttendEvent1||false,
                isAttendEvent2:data?.isAttendEvent2||false,
                isRegisterTgather:data?.isRegisterTgather||false
            })
            if(result2.errno){
                alert(`${JSON.stringify(result2.message||"Error (70008)")}`)
                setisloading(false)
                return
            }else{
                setisShowSuccessfulPage(true)
            }
        }
        setisloading(false)
        

    }

    const [showChoosePopup,setshowChoosePopup]=useState(null)
    const toggleChoosePopup = (type)=>()=>{
        if(showChoosePopup===type) setshowChoosePopup(null)
        else
            setshowChoosePopup(type)
    }
    const handleSetWorkEx=(workEx)=>()=>{
        setData({...data,workEx})
        setshowChoosePopup(null)
    }
    const handleSetGender=(gender)=>()=>{
        setData({...data,gender})
        setshowChoosePopup(null)
    }
    const handleSetdateOfBirthMonth=(dateOfBirthMonth)=>()=>{
        setData({...data,dateOfBirthMonth})
        setshowChoosePopup(null)
    }
    const handleSetposition=(val)=>()=>{
        setData({...data,position: val})
        setshowChoosePopup(null)
    }
    const handleSetDegree=(val)=>()=>{
        setData({...data,degree: val})
        setshowChoosePopup(null)
    }
    const handleSetAge=(val)=>()=>{
        setData({...data,age: val})
        setshowChoosePopup(null)
    }
    const handleSetVisa=(val)=>()=>{
        setData({...data,visa: val})
        setshowChoosePopup(null)
    }
    const handleSetdateOfBirthDate=(dateOfBirthDate)=>()=>{
        setData({...data,dateOfBirthDate})
        setshowChoosePopup(null)
    }
    const getAvailableDate=()=>{
        let max= 31
        if(['2'].includes(data?.dateOfBirthMonth)) max =29
        if(['4','6','9','11',].includes(data?.dateOfBirthMonth)) max =30
        const valArr = []
        for(let i = 1; i <= max; i++){
            valArr.push(`${i}`)
        } 
        return valArr
    }
    const isReady=()=>{
        if(!isVerified)return false
        if( !data.firstname ) return false
        if( !data.lastname ) return false
        if( !data.age ) return false
        if( !data.email ) return false
        if( !data.degree ) return false
        if( !data.workEx ) return false
        if( !data.visa ) return false
        if((!data.isAttendEvent1) && (!data.isAttendEvent2)){return false}
        if(!data.isAcknowledged){return  false}
        
        return true
    }
    if(isShowSuccessfulPage) return (
        <div className="w-full h-full flex flex-col items-center justify-start p-[16px] bg-[#ddd]" style={{overflowY:'auto'}}>
            
            <div className="relative w-full max-w-[1300px]">
                <div className="relative w-full border-white border-2 p-[24px] rounded-[50px] flex flex-col justify-start items-center mt-[64px] overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)',zIndex:1,}}/>
                    <div className="flex flex-col w-full items-center gap-[16px] text-center" style={{zIndex:2}}>
                        <div className="font-[350] text-[32px] text-[#6E604C]">第二季「2025香港國際人才職業博覽會」</div>
                        <div className="font-[700] text-[32px] text-[#6E604C]">進場登記</div>
                        <CompleteSvg width={windowSize.innerWidth<=1024?220:286}/>

                        <div className="font-[400] d-text-28-m-22 text-[#6E604C] mt-[16px]">
                            {data?.lastname} {data?.firstname} {data?.englishName||""}, 我們衷心期待你的光臨。
                        </div>
                        <div className="font-[400] d-text-28-m-22 text-[#6E604C] mt-[-16px]">
                            以下是你的登記資料
                        </div>
                        <div className="font-[400] text-[18px] text-[#6E604C] mt-[12px]">
                            電郵地址 &nbsp;&nbsp; {data?.email}
                        </div>
                        <div className="font-[350] d-text-28-m-22 text-[#6E604C] mt-[12px]">
                            您已登記成功，我們正在確認您的信息，並將於近日內發送確認電子郵件給您。
                        </div>
                        <div className="font-[700] d-text-36-m-24 text-[#0F737E] mt-[24px]">
                            入場時請使用T.Gather App進行入場登記
                        </div>
                        <div className="download-button max-w-full mt-[24px] flex justify-center items-center text-white d-text-32-m-24 font-[700] rounded-[99px]" style={{background:'linear-gradient(94.86deg, #263E54 5.53%, #0C6E7D 51.67%, #264554 94.27%)',border: '3px solid #C1C1C1'}}>
                            下載 T.Gather
                        </div>

                        <div className="flex flex-row items-center max-w-[600px]" style={{gap:8}}>
                            <div className="cursor-pointer" onClick={()=>{window.open('https://apps.apple.com/us/app/t-gather/id6738165815', '_blank');}}>
                                <img src='/apple.png' alt='apple'/>
                            </div>
                            <div className="cursor-pointer" onClick={()=>{window.open('https://play.google.com/store/apps/details?id=com.aquila.tgather', '_blank');}}>
                                <img src='/google.png' alt='apple'/>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
    return (
        <div className='w-full flex-col items-center relative'>
            {/* <div className='w-full h-[93vh] sticky top-0' style={{zIndex:1}}>
                <img src='../img/aboutus/newbg_bg.png' className='h-[93vh] w-full' style={{objectFit:'cover', aspectRatio:3840/1774}}></img>
                <div className='w-full h-full flex flex-row-col items-center justify-center absolute top-0 left-0' style={{gap:24}}>
                    <img src='../img/aboutus/newbg_phone.png' className='max-w-[25vw] min-w-[200px] d-flex1-m-none' style={{aspectRatio:427/533, height:undefined}}></img>
                    <div className='flex flex-col items-start' style={{}}>
                        <img src='../img/aboutus/newbg_text.png' className='max-w-[15vw] min-w-[200px] mb-[10%]' style={{aspectRatio:300/250, height:undefined, flex:1}}></img>
                        <div className='flex flex-row items-center justify-center gap-[8px]'>
                            <AppleBtn />
                            <PlayBtn />
                        </div>
                    </div>
                </div>
            </div> */}
            <Nav scrollRef={scrollRef} handleSetRightNav={handleSetRightNav} onlyIcon={true}/>
            <div className='grey-bg w-full flex flex-col items-center relative p-[24px]' style={{backgroundImage: `url(/newlanding/img/home/bg_grain.png)`,zIndex:2,backgroundSize:'cover' }}>
                <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px] border border-[#8c866b] rounded-[50px]">
                    <div className='absolute bottom-0 w-full h-full' style={{zIndex:1}}/>
                    <div className="flex flex-col w-full items-center gap-[16px]" style={{zIndex:2}}>
                        <div className="font-[350] d-text-32-m-20 text-[#6E604C] text-center">第二季「2025香港國際人才職業博覽會」</div>
                        <div className="font-[700] d-text-32-m-20 text-[#6E604C] text-center">進場登記</div>
                        <div className="font-[400] text-[13px] text-[#473F3A] text-center">請提供更多關於你的信息, 您提供的個人資訊將用於您的 T.Gather 會員註冊</div>
                        <div className="font-[400] text-[13px] text-[#473F3A] text-center">
                            請提供更多關於你的信息, 您提供的個人資訊將用於⾼峰論壇及 T.Gather 會員註冊 
                            請提供您的更多信息，用於首季「2025香港國際人才職業博覽會」的報名登記
                        </div> 

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                                <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                    <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                    *中文名<div className="text-[12px]">(Chinese Firstname)</div>
                                    </div>
                                    
                                    <div className="flex flex-row w-full gap-[24px]">
                                        <input value={data.firstname||''} onChange={onChangefirstname} className="flex-1 bg-[transparent] border-none" placeholder="請填寫"/>
                                    </div>
                                </div>
                                <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{borderBottom:'1px solid #00000033'}}>
                                    <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                    *中文姓<div className="text-[12px]">(Chinese Lastname)</div>
                                    </div>
                                    
                                    <div className="flex flex-row w-full gap-[24px]">
                                        <input value={data.lastname||''} onChange={onChangelastname} className="flex-1 bg-[transparent] border-none" placeholder="請填寫"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-[12px] text-[#6E604C]">請與身份證件上保持一</div>
                        <div className="text-[12px] text-[#6E604C]">Please keep it the same as on your ID</div>
                        <div className="relative w-full flex flex-col items-start gap-[8px] max-w-[800px] py-[8px] d-ml8-m-0" style={{borderBottom:'1px solid #00000033'}}>
                            <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                            年齡 <div className="text-[12px]">(Age)</div>
                                {/* <div className="text-[12px] text-[#00000033]">(可選填)</div> */}
                            </div>
                            <div onClick={toggleChoosePopup('age')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                <div className="font-[400] text-[18px] flex-1" style={{color:data?.age?'black':"#00000033"}}>{data?.age||'請選擇'}</div>
                                <DownArrow/>
                            </div>
                            {showChoosePopup==='age'&&<div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col">
                                {AGE.map(item=>
                                    <div onClick={handleSetAge(item)} key={item} className="text-[#000] font-[400] text-[18px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                        {item}
                                    </div>
                                )}
                            </div>}
                        </div>

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="w-full flex flex-col items-start gap-[8px] max-w-[800px]">
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">手機號 <div className="text-[12px]">(Mobile)</div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{borderBottom:'1px solid #00000033'}}>
                                        <input onChange={onChangeMobile} value={data?.mobile||''} className="w-full bg-[transparent] border-none" placeholder="請填寫"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                    微信號 <div className="text-[12px]">(Wechat ID)</div>
                                    <div className="text-[12px] text-[#00000033]">(可選填)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.wechat||''} onChange={onChangeWechat} className="flex-1 bg-[transparent] border-none" placeholder="請填寫"/>
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex flex-col items-start gap-[8px] max-w-[800px] pt-[8px]">
                            <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">*電郵 <div className="text-[12px]">(Email)</div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{borderBottom:'1px solid #00000033'}}>
                                    <input disabled={isVerified} onChange={onChangeEmail} value={data?.email||''} className="w-full bg-[transparent] border-none" placeholder="請填寫"/>
                                </div>

                                <div onClick={onRequestOtp}  className="w-[140px] h-[39px] cursor-pointer d-flex-m-hidden justify-center items-center text-white text-[14px] font-[500] rounded-[99px]" style={{opacity:isVerified?.5:1,background:'linear-gradient(180deg, #8C866B 0%, rgba(143, 137, 109, 0.96) 14%, rgba(153, 146, 116, 0.84) 32%, rgba(169, 160, 127, 0.8) 53%, rgba(153, 146, 116, 0.4) 100%)',border: '1px solid #8F896DF5'}}>
                                    發送驗證碼
                                </div>
                            </div>
                        </div>
                        <div onClick={onRequestOtp} className="max-w-[800px] w-[100%] h-[39px] cursor-pointer d-hidden-m-flex justify-center items-center text-white text-[14px] font-[500] rounded-[99px]" style={{background:'linear-gradient(180deg, #8C866B 0%, rgba(143, 137, 109, 0.96) 14%, rgba(153, 146, 116, 0.84) 32%, rgba(169, 160, 127, 0.8) 53%, rgba(153, 146, 116, 0.4) 100%)',border: '1px solid #8F896DF5'}}>
                            發送驗證碼
                        </div>
                        {showRegisterError&&
                            <div className="text-[red] font-[400] text-[14px] flex flex-row items-left w-full max-w-[800px] ">
                                {showRegisterError}
                            </div>
                        }
                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                *您的最高學位<div className="text-[12px]">(Your highest degree)</div>
                                </div>                   
                                {[undefined,'學士Bachelor','碩士Master','博士Doctor'].includes(data?.degree) && <div onClick={toggleChoosePopup('degree')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[18px] flex-1" style={{color:data?.degree?'black':"#00000033"}}>{data?.degree||'請選擇'}</div>
                                    <DownArrow/>
                                </div>}
                                {showChoosePopup==='degree'&&<div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col max-h-[200px] overflow-auto" >
                                    {EDU.map(item=>
                                        <div onClick={handleSetDegree(item === '其他Other' ? '' : item)} key={item} className="text-[#000] font-[400] text-[12px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {item}
                                        </div>
                                    )}
                                </div>}
                                {!['學士Bachelor','碩士Master','博士Doctor', undefined].includes(data?.degree) && <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data?.degree || ''} onChange={e => onChangeDegree(e)} className="flex-1 bg-[transparent]" placeholder="請填寫"/>
                                </div>}
                            </div>
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                    畢業學校及專業<div className="text-[12px]">(School and major)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.school||''} onChange={onChangeSchoolMajor} className="flex-1 bg-[transparent] border-none" placeholder="請填寫"/>
                                </div>
                            </div>
                        </div>
                        <div className="relative w-full flex flex-col items-start gap-[8px] max-w-[800px] py-[8px] d-ml8-m-0" style={{borderBottom:'1px solid #00000033'}}>
                            <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                            *您的工作經驗 <div className="text-[12px]">(Your work experience)</div>
                                {/* <div className="text-[12px] text-[#00000033]">(可選填)</div> */}
                            </div>
                            <div onClick={toggleChoosePopup('workEx')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                <div className="font-[400] text-[18px] flex-1" style={{color:data?.workEx?'black':"#00000033"}}>{data?.workEx||'請選擇'}</div>
                                <DownArrow/>
                            </div>
                            {showChoosePopup==='workEx'&&<div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col">
                                {WORKEX.map(item=>
                                    <div onClick={handleSetWorkEx(item)} key={item} className="text-[#000] font-[400] text-[18px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                        {item}
                                    </div>
                                )}
                            </div>}
                        </div>
                        {/* <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                目前工作單位名稱及職位 <div className="text-[12px]">(Current employer and position)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.employer||''} onChange={onChangeEmployer} className="flex-1 bg-[transparent]" placeholder="如暫無工作，請寫「無」#If you are not currently employed • please fill in N/A"/>
                                </div>
                            </div>
                        </div> */}
                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                目前工作單位名稱<div className="text-[12px]">(Current employer)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.company||''} onChange={onChangecompany} className="flex-1 bg-[transparent] border-none" placeholder="請填寫"/>
                                </div>
                            </div>
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                職位<div className="text-[12px]">(position)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.position||''} onChange={onChangePosition} className="flex-1 bg-[transparent] border-none" placeholder="請填寫"/>
                                </div>
                            </div>
                        </div>
                        <div className="relative w-full flex flex-col items-start gap-[8px] max-w-[800px] py-[8px] d-ml8-m-0" style={{borderBottom:'1px solid #00000033'}}>
                            <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                            *您的香港簽證類型 <div className="text-[12px]">(Your Hong Kong visa)</div>
                                {/* <div className="text-[12px] text-[#00000033]">(可選填)</div> */}
                            </div>
                            <div onClick={toggleChoosePopup('visa')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                <div className="font-[400] text-[18px] flex-1" style={{color:data?.visa?'black':"#00000033"}}>{data?.visa||'請選擇'}</div>
                                <DownArrow/>
                            </div>
                            {showChoosePopup==='visa'&&<div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col">
                                {VISA.map(item=>
                                    <div onClick={handleSetVisa(item)} key={item} className="text-[#000] font-[400] text-[18px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                        {item}
                                    </div>
                                )}
                            </div>}
                        </div>
                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                *出席環節 <div className="text-[12px]">(Attendance Session)</div>
                                    <div className="text-[12px] text-[#00000033]">(可多選Multiple choices)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input type="checkbox" checked={data?.isAttendEvent1||false} onChange={(e)=>{setData({...data,isAttendEvent1:!data.isAttendEvent1})}}/> 
                                    1.國際人才職業博覽會
                                </div>
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input type="checkbox" checked={data?.isAttendEvent2||false} onChange={(e)=>{setData({...data,isAttendEvent2:!data.isAttendEvent2})}}/> 
                                    2.國際人才在港發展研討會
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>

                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                註冊T.Gather會員 <div className="text-[12px]">(T.Gather Registration)</div>
                                </div>
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input type="checkbox" checked={data?.isRegisterTgather||false} onChange={(e)=>{setData({...data,isRegisterTgather:!data.isRegisterTgather})}}/> 
                                    同時註冊成為T.Gather會員，利用QR code 進場
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{borderBottom:'1px solid #00000033'}}>
                                <div className="text-[#6E604C] font-[400] text-[18px] flex flex-row items-end">
                                *聲明 <div className="text-[12px]">(Statement)</div>
                                </div>
                                
                                <div className="flex flex-row w-full gap-[24px] text-[11px]">
                                    <input type="checkbox" checked={data?.isAcknowledged||false} onChange={(e)=>{setData({...data,isAcknowledged:!data.isAcknowledged})}}/> 
                                    本人謹此聲明，本人就此項申請所提供之一切資料均屬真實有效，如有虛報本人之申請將會被取消。本人授權香港優才及專才協會及香港人才集團使用本人提供之資料作統計、活動等指定用途。本人將遵守「2025香港國際人才職業博覽會」的各項條款
                                    <br/>I declare that the information given in this application form is true and complete, and give my consent these information to be used for the statistical and activities of Hong Kong Quality And Talent Migrants Association, and Hong Kong Talents group. I will comply with all conditions, rules and regulations of Hong Kong International Talents Career Expo.
                                </div>
                            </div>
                        </div>
                        
                        <div onClick={handleCompleteRegister} className="max-w-full register-button mt-[16px] cursor-pointer flex justify-center items-center text-white d-text-24-m-14 font-[700] rounded-[99px]" style={{background:'linear-gradient(180deg, #8C866B 0%, rgba(143, 137, 109, 0.96) 14%, rgba(153, 146, 116, 0.84) 32%, rgba(169, 160, 127, 0.8) 53%, rgba(153, 146, 116, 0.4) 100%)',border: '1px solid #8F896DF5',opacity:isReady()?1:.3}}>
                            登記 (Register)
                        </div>
  
                    </div>            
                </div>  
            </div>
            {isShowOtpPopup&&<div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000070] flex items-center justify-center p-[16px] z-[3]">
                <div className="flex flex-col w-full max-w-[800px] bg-[#fff] rounded-[24px] d-px64-m-px-16 py-[32px] justify-center items-center" style={{boxSizing:'border-box'}}>
                    <div className="text-[#6E604C] text-[32px] font-[700]">驗證</div>
                    <div className="flex flex-row text-[#938474] font-[400] text-[18px] w-full text-left mt-[64px]"> 
                        驗證碼已發送至
                        <div className="ml-[16px] font-[700] d-flex-m-hidden">{data?.email||''}</div>
                    </div>
                    <div className="font-[700] d-hidden-m-flex text-[#938474] text-[12px] text-left w-full">{data?.email||''}</div>

                    <div className='w-full flex flex-row justify-start mt-5 ' style={{gap:8,boxSizing:'border-box'}}>
                        <div className='flex-[1]' style={{height:undefined,aspectRatio:1,}}>
                            <input value={num1} onChange={handleOtpInput(1)} ref={ref1} className='w-full h-full text-[32px] text-center' maxLength={1} style={{borderColor:'#8D876C',borderWidth:.5,borderRadius:8,boxSizing:'border-box'}}/>
                        </div>
                        <div className='flex-[1]' style={{height:undefined,aspectRatio:1,}}>
                            <input value={num2} onChange={handleOtpInput(2)} ref={ref2} className='w-full h-full text-[32px] text-center' maxLength={1} style={{borderColor:'#8D876C',borderWidth:.5,borderRadius:8,boxSizing:'border-box'}}/>
                        </div>
                        <div className='flex-[1]' style={{height:undefined,aspectRatio:1,}}>
                            <input value={num3} onChange={handleOtpInput(3)} ref={ref3} className='w-full h-full text-[32px] text-center' maxLength={1} style={{borderColor:'#8D876C',borderWidth:.5,borderRadius:8,boxSizing:'border-box'}}/>
                        </div>
                        <div className='flex-[1]' style={{height:undefined,aspectRatio:1,}}>
                            <input value={num4} onChange={handleOtpInput(4)} ref={ref4} className='w-full h-full text-[32px] text-center' maxLength={1} style={{borderColor:'#8D876C',borderWidth:.5,borderRadius:8,boxSizing:'border-box'}}/>
                        </div>
                        <div className='flex-[1]' style={{height:undefined,aspectRatio:1,}}>
                            <input value={num5} onChange={handleOtpInput(5)} ref={ref5} className='w-full h-full text-[32px] text-center' maxLength={1} style={{borderColor:'#8D876C',borderWidth:.5,borderRadius:8,boxSizing:'border-box'}}/>
                        </div>
                        <div className='flex-[1]' style={{height:undefined,aspectRatio:1,}}>
                            <input value={num6} onChange={handleOtpInput(6)} ref={ref6} className='w-full h-full text-[32px] text-center' maxLength={1} style={{borderColor:'#8D876C',borderWidth:.5,borderRadius:8,boxSizing:'border-box'}}/>
                        </div>
                    </div>

                    <div className='flex flex-row w-full items-center justify-between mt-5'>
                        {countdown>0
                            ?<div className='text-[#949494] text-[14px]'>{countdown}秒後重新發送</div>
                            :<div onClick={onRequestOtp} className='underline text-[14px] text-[#6E604C] cursor-pointer'>重新發送</div>
                        }
                    </div>

                    <div onClick={handleLoginButton} className="d-flex-m-hidden h-[72px] bg-[#0F737E] w-full rounded-[99px] text-white text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[64px]">
                        確認
                    </div>
                    <div onClick={cancelOtp} className="d-flex-m-hidden h-[72px] bg-[#fff] w-full rounded-[99px] text-[#0F737E] text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[4px]">
                        取消
                    </div>
                    {/* <div onClick={handleLoginButton} className="d-hidden-m-flex h-[48px] bg-[#0F737E] w-full rounded-[99px] text-white text-[16px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[64px]">
                        確認
                    </div>
                    <div onClick={cancelOtp} className="d-hidden-m-flex h-[48px] bg-[#fff] w-full rounded-[99px] text-[#0F737E] text-[16px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[4px]">
                        取消
                    </div> */}

                </div>
            </div>}
            <Footer />
            {isloading&&<LoadingPage/>}
        </div>
    );
};

export default AboutUs;